import * as React from "react";

export function useOptimisticHide() {
    const [hidden, setHidden] = React.useState<Set<string>>(new Set());

    const hide = React.useCallback((id: string) => {
        setHidden((s) => {
            const next = new Set(s);
            next.add(id);
            return next;
        });
    }, []);

    const unhide = React.useCallback((id: string) => {
        setHidden((s) => {
            if (!s.has(id)) return s;
            const next = new Set(s);
            next.delete(id);
            return next;
        });
    }, []);

    const filterVisible = React.useCallback(
        <T extends { id: string; status?: string }>(rows: T[] | undefined, status = "pending"): T[] => {
            if (!rows) return [];
            return rows.filter((r) => (r.status ? r.status === status : true) && !hidden.has(r.id));
        },
        [hidden]
    );

    const reset = React.useCallback(() => setHidden(new Set()), []);

    return { hidden, hide, unhide, filterVisible, reset };
}
